import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import { propertyImages } from '../mock';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';

export const HeroGallery = () => {
  const [showAllPhotos, setShowAllPhotos] = useState(false);
  const { language } = useLanguage();
  const t = content[language];

  // When gallery opens, temporarily hide the banner so dialog is on top
  useEffect(() => {
    const banner = document.getElementById('preview-banner');
    if (banner) {
      if (showAllPhotos) {
        banner.style.setProperty('z-index', '1', 'important');
      } else {
        banner.style.removeProperty('z-index');
      }
    }
  }, [showAllPhotos]);

  const displayImages = propertyImages.slice(0, 5);
  const mainImage = displayImages[0];
  const sideImages = displayImages.slice(1, 5);

  return (
    <>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="relative rounded-xl overflow-hidden group cursor-pointer">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 h-[400px] md:h-[500px]">
            {/* Main Image */}
            <div 
              className="relative col-span-1 h-full overflow-hidden"
              onClick={() => setShowAllPhotos(true)}
            >
              <img
                src={mainImage.url}
                alt={mainImage.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>

            {/* Side Grid */}
            <div className="hidden md:grid grid-cols-2 gap-2 h-full">
              {sideImages.map((image, index) => (
                <div
                  key={image.id}
                  className="relative overflow-hidden"
                  onClick={() => setShowAllPhotos(true)}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Show All Photos Button */}
          <Button
            onClick={() => setShowAllPhotos(true)}
            variant="secondary"
            className="absolute bottom-4 right-4 bg-white hover:bg-gray-100 shadow-lg"
          >
            {t.showAllPhotos}
          </Button>
        </div>
      </div>

      {/* Full Gallery Dialog */}
      <Dialog open={showAllPhotos} onOpenChange={setShowAllPhotos}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto z-[9999]">
          <DialogTitle className="sr-only">{t.showAllPhotos}</DialogTitle>
          <div className="relative">
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-2 right-2 z-[10001] hover:bg-gray-200"
              onClick={() => setShowAllPhotos(false)}
            >
              <X className="h-5 w-5" />
            </Button>
            <div className="grid grid-cols-1 gap-4 pt-12">
              {propertyImages.map((image) => (
                <img
                  key={image.id}
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-auto object-cover rounded-lg"
                />
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
